// 📁 src/utils/calculateTotal.js
import { logDev } from "../utils/logger.js"

/**
 * Calcule le total d'une période pour une liste de contacts.
 * @param {Array} contacts - Liste des contacts (chaque contact a des champs periode1, periode2, etc.)
 * @param {string} periodeKey - La clé de la période (ex: "periode1", "periode2")
 * @returns {number} - La somme des valeurs pour cette période
 */

export function calculateTotal(contacts, periodeKey) {
  if (!Array.isArray(contacts)) return 0;

  const total = contacts.reduce((sum, contact) => {
    const val = contact[periodeKey];
    const num = typeof val === "number" ? val : parseInt(val, 10);
    return sum + (isNaN(num) ? 0 : num);
  }, 0);

  logDev("[calculateTotal] total calculé", { periodeKey, total, contacts });
  return total;
}
